module.exports = __webpack_public_path__ + "img/givens-line-short.61cf41e4.svg";